import ValidationInterface from '@/plans/common/validation-interface';

export default class extends ValidationInterface {
  async requires() {
    return [];
  }

  async conflicts() {
    //todo UI restriction
    return ["zwbbasic", "zwbplus"];
  }
}
